import * as Colors from './colors'

export const colors = [
  Colors.coral,
  Colors.cyan,
  Colors.darkBlue,
]
